// Termine im Immobilienbereich: Zuordnung der DB-Typen zu den Kalender-Kategorien
// des Designs (Entscheidung User 11.10.2026) und das Monatsraster.

export type TerminKategorie = 'wartung' | 'vermietung' | 'versammlung' | 'ablesung' | 'sonstige';

export const KATEGORIE_INFO: Record<TerminKategorie, { label: string; farbe: string; flaeche: string }> = {
  wartung: { label: 'Wartung', farbe: 'var(--warn)', flaeche: 'var(--warn-soft)' },
  vermietung: { label: 'Vermietung', farbe: 'var(--info)', flaeche: 'var(--info-soft)' },
  versammlung: { label: 'Versammlung', farbe: 'var(--acc)', flaeche: 'var(--acc-soft)' },
  ablesung: { label: 'Ablesung', farbe: 'var(--ok)', flaeche: 'var(--ok-soft)' },
  sonstige: { label: 'Sonstige', farbe: 'var(--ink3)', flaeche: 'var(--fill2)' },
};

/**
 * besichtigung → Vermietung · wartung → Wartung · meeting → Versammlung ·
 * Ablesung über typ_freitext (oder Titel) · alles andere → Sonstige.
 */
export function terminKategorie(t: { typ?: string | null; typ_freitext?: string | null; titel?: string | null }): TerminKategorie {
  const typ = (t.typ ?? '').toLowerCase();
  const frei = `${t.typ_freitext ?? ''} ${typ === 'sonstig' ? t.titel ?? '' : ''}`.toLowerCase();
  if (/ablesung|zählerstand|zaehlerstand/.test(frei) || typ === 'ablesung') return 'ablesung';
  if (typ === 'besichtigung') return 'vermietung';
  if (typ === 'wartung') return 'wartung';
  if (typ === 'meeting') return 'versammlung';
  return 'sonstige';
}

/** Lokales Datum (YYYY-MM-DD) eines Termins – ganztägige Termine ohne Zeitzonen-Verschiebung. */
export function terminTag(start: string, ganztaegig?: boolean | null): string {
  if (ganztaegig || /^\d{4}-\d{2}-\d{2}$/.test(start)) return start.slice(0, 10);
  const d = new Date(start);
  if (Number.isNaN(d.getTime())) return start.slice(0, 10);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export interface RasterTag { iso: string; tag: number; imMonat: boolean }

/** Wochenraster eines Monats, Montag zuerst, inkl. Randtagen der Nachbarmonate. */
export function monatsRaster(jahr: number, monat: number): RasterTag[][] {
  const erster = new Date(Date.UTC(jahr, monat - 1, 1));
  const versatz = (erster.getUTCDay() + 6) % 7;
  const tage = new Date(Date.UTC(jahr, monat, 0)).getUTCDate();
  const zeilen = Math.ceil((versatz + tage) / 7);
  const raster: RasterTag[][] = [];
  for (let z = 0; z < zeilen; z++) {
    const woche: RasterTag[] = [];
    for (let s = 0; s < 7; s++) {
      const d = new Date(Date.UTC(jahr, monat - 1, 1 - versatz + z * 7 + s));
      woche.push({ iso: d.toISOString().slice(0, 10), tag: d.getUTCDate(), imMonat: d.getUTCMonth() === monat - 1 });
    }
    raster.push(woche);
  }
  return raster;
}

/** Tage bis zu einem Datum (ganze Tage, lokal); negativ = vergangen. */
export function tageBis(isoTag: string, heute: string): number {
  const a = Date.UTC(Number(heute.slice(0, 4)), Number(heute.slice(5, 7)) - 1, Number(heute.slice(8, 10)));
  const b = Date.UTC(Number(isoTag.slice(0, 4)), Number(isoTag.slice(5, 7)) - 1, Number(isoTag.slice(8, 10)));
  return Math.round((b - a) / 86_400_000);
}

export function inTagenText(tage: number): string {
  if (tage === 0) return 'heute';
  if (tage === 1) return 'morgen';
  if (tage > 1) return `in ${tage} Tagen`;
  if (tage === -1) return 'gestern';
  return `vor ${-tage} Tagen`;
}
